import React from 'react';

export default function Logo({
  className='',
  iconSize='w-6 h-6',
  textSize='text-2xl'
}) {
  return (
    <div className={`flex items-center gap-2 group ${className}`}>
      {/* Aesthetic Sparkle/Curation Mark (decorative) */}
      <div className="relative flex items-center justify-center shrink-0">
        <div className="absolute inset-0 bg-[#8B7355]/30 rounded-full blur-md group-hover:blur-lg transition-all duration-500 opacity-0 group-hover:opacity-100" aria-hidden="true"></div>
        <svg
          className={`${iconSize} text-[#8B7355] transform group-hover:rotate-12 transition-transform duration-500 ease-out relative z-10`}
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          focusable="false"
        >
          <path d="M12 1.5C12 1.5 12 10.5 20.5 12C12 13.5 12 22.5 12 22.5C12 22.5 12 13.5 3.5 12C12 10.5 12 1.5 12 1.5Z" />
        </svg>
      </div>
      {/* Typography: Mix of bold serif and light italic serif */}
      <div className={`${textSize} tracking-tight flex items-baseline`}>
        <span className="font-serif font-semibold text-[#2C2A29]">Curate</span>
        <span className="font-serif italic font-light text-[#8B7355]">Ed</span>
        <span className="w-1.5 h-1.5 rounded-full bg-[#8B7355] ml-1 mb-1.5 opacity-80" aria-hidden="true"></span>
      </div>
    </div>
  );
}